export const getTreeViewWithSearchBoxStyles = (_, { palette = {} }) => ({
  treeViewWithSearchBox: {
    '& .grid-expanded-icon:before': {
      content: '"\\E70D"',
      fontFamily: 'MsAds MDL2 Assets',
      fontSize: '12px',
      color: palette.neutralSecondary,
      marginRight: '8px',
      marginTop: '2px',
    },
    '& .grid-expand-icon:before': {
      content: '"\\E76C"',
      fontFamily: 'MsAds MDL2 Assets',
      fontSize: '12px',
      color: palette.neutralSecondary,
      marginRight: '8px',
      marginTop: '2px',
    },
    '& .tree-view-container': {
      paddingLeft: 8,
    },
  },
});
